import { STATS } from "@/lib/site-data";

export const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="bg-white border-y border-slate-200 py-20"
    >
      <div className="container-narrow">
        <div className="overline text-emerald-800 mb-10">— By the numbers</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="bg-white p-8 md:p-10"
            >
              <div className="font-serif text-4xl md:text-5xl text-slate-950 tracking-tight">
                {s.value}
              </div>
              <div className="mt-3 text-sm text-slate-600 leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
